import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询模板演示分类
export const getCustomizeList = params => {
    return reqGet("get", "/app-yijiu-backstage/getCustomizeList", params);
};

// 删除模板演示分类
export const deleteCustomize = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteCustomize", params);
};

  // 增加模板演示分类
export const addCustomize = params => {
    return req("post", "/app-yijiu-backstage/addCustomize", params);
};

  // 修改模板演示分类  
  export const updateCustomize = params => {
    return req("post", "/app-yijiu-backstage/updateCustomize", params);
};



// WEBPACK FOOTER //
// ./src/api/manage/customize.js